import {
  ActionForm,
  Button,
  ClickToCopy,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Tooltip,
  useTableContext,
} from "@bleu.builders/ui";
import { Pencil2Icon, TrashIcon } from "@radix-ui/react-icons";
import { FileCheck, FileQuestion } from "lucide-react";
import React from "react";

import { Link } from "#/components/Link";
import { formatDate } from "#/lib/formatDate";
import { cn } from "#/lib/utils";

export function DiagnosesTable() {
  // @ts-expect-error TS(2339) FIXME: Property 'table' does not exist on type '{}'.
  const { table } = useTableContext();

  return (
    <div className="relative w-full overflow-auto">
      <Table
        style={{
          borderCollapse: "separate",
          borderSpacing: "0 10px",
          marginTop: "-10px",
        }}
      >
        <TableHeader className="bg-background">
          <TableRow className="hover:rounded-t-md">
            <TableHead className="border-b px-3">Nome do Cliente</TableHead>
            <TableHead className="border-b px-3">Email</TableHead>
            <TableHead className="border-b px-3">
              Status do Diagnóstico
            </TableHead>
            <TableHead className="border-b px-4">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {table.getRowModel().rows?.length ? (
            table.getRowModel().rows.map((row, index) => {
              return (
                <TableRow
                  className="hover:bg-background hover:rounded-md"
                  key={row.id}
                >
                  <TableCell className="p-0 w-1/4">
                    <div
                      className={cn("border rounded-md px-3 py-2 mr-3", {
                        "bg-muted": index % 2 === 0,
                        "bg-background": index % 2 !== 0,
                      })}
                    >
                      {row.original.title}
                    </div>
                  </TableCell>
                  <TableCell className="p-0 w-1/4">
                    <div
                      className={cn("border rounded-md px-3 py-2 mr-3", {
                        "bg-muted": index % 2 === 0,
                        "bg-background": index % 2 !== 0,
                      })}
                    >
                      {row.original.external_creator_email || "-"}
                    </div>
                  </TableCell>
                  <TableCell className="p-0 w-1/4">
                    <div
                      className={cn(
                        "border rounded-md px-3 py-2 mr-1 flex justify-between items-center",
                        {
                          "bg-muted": index % 2 === 0,
                          "bg-background": index % 2 !== 0,
                        },
                      )}
                    >
                      {row.original.is_external ? (
                        <span>
                          Link criado em {formatDate(row.original.created_at)}
                        </span>
                      ) : row.original.is_completed ? (
                        <span>Finalizado</span>
                      ) : (
                        <span>
                          Criado em {formatDate(row.original.created_at)}
                        </span>
                      )}
                      <div className="flex items-center gap-2">
                        {row.original.is_external && (
                          <ClickToCopy
                            text={row.original.external_url}
                            className="text-black"
                          />
                        )}
                        <Tooltip
                          className="bg-background text-foreground max-w-xs border border-muted-foreground"
                          content={
                            row.original.is_completed
                              ? "Diagnóstico finalizado"
                              : "Diagnóstico não finalizado"
                          }
                        >
                          {row.original.is_completed ? (
                            <FileCheck className="size-4 text-primary" />
                          ) : (
                            <FileQuestion className="size-4 text-gray-600" />
                          )}
                        </Tooltip>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="flex gap-5 px-2 py-0 justify-between">
                    <Link
                      to={
                        row.original.actions.find(
                          (r) => r.name == "Ver Matches",
                        ).url_path
                      }
                      className="w-full"
                      onClick={(e) =>
                        !row.original.is_completed && e.preventDefault()
                      }
                    >
                      <Button
                        disabled={!row.original.is_completed}
                        className="w-full"
                      >
                        Resultado
                      </Button>
                    </Link>
                    <Link
                      to={
                        row.original.actions.find((r) => r.name === "Editar")
                          .url_path
                      }
                    >
                      <Button
                        className="h-8 w-12"
                        size="icon"
                        variant="outline"
                      >
                        <Pencil2Icon className="size-4" />
                        <span className="sr-only">Edit</span>
                      </Button>
                    </Link>
                    <ActionForm
                      row={row}
                      action={row.original.actions?.find(
                        (a) => a.name === "Deletar",
                      )}
                    >
                      <Button
                        className="h-8 w-12"
                        size="icon"
                        variant="destructive"
                      >
                        <TrashIcon className="size-4" />
                        <span className="sr-only">Delete</span>
                      </Button>
                    </ActionForm>
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <div className="mt-4 w-full mr-4 overflow-y-auto max-h-[80vh] min-h-[10vh]">
              Nenhum resultado encontrado.
            </div>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
